<section class="col-xs-12 col-sm-12 returns_titlesection" id="forUKReturns" >
    <div class="returns_header" *ngIf="this.pageLabel  != 'returnsDashboardThankYouPage'">Returns</div>
    <div class="returns_header" *ngIf="this.pageLabel === 'returnsDashboardThankYouPage'">Announcements</div>
</section>
<div class="clearboth"></div>
